import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PermitTagService } from '../../services/permit-tag.service';
import { MessageService } from '../../../global/services/message/message.abstract.service';
import { BcitiConfirmDialogComponent } from '../../../global/components/dialogs/bciti-confirm-dialog/bciti-confirm-dialog.component';

@Component({
    selector: 'app-permit-config-tags',
    templateUrl: './permit-config-tags.component.html',
    styleUrls: ['./permit-config-tags.component.scss'],
})
export class PermitConfigTagsComponent implements OnInit, OnDestroy {
    tags: string[] = [];
    loading = true;

    private destroy$ = new Subject<void>();

    constructor(
        private tagService: PermitTagService,
        private dialog: MatDialog,
        private translate: TranslateService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        this.loadTags();
    }

    loadTags(): void {
        this.loading = true;
        this.tagService
            .getTags()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (tags) => {
                    this.tags = tags || [];
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                    this.messageService.error(this.translate.instant('permit.config.common.error'));
                },
            });
    }

    confirmDelete(tag: string): void {
        const dialogRef = this.dialog.open(BcitiConfirmDialogComponent, {
            width: '400px',
            data: {
                dialog: {
                    title: this.translate.instant('permit.config.tags.delete_title'),
                    body: this.translate.instant('permit.config.tags.delete_body', { tag }),
                    confirmLabel: this.translate.instant('permit.config.common.delete'),
                    cancelLabel: this.translate.instant('permit.config.common.cancel'),
                    confirmButtonClass: 'danger-btn',
                },
                component: { data: {}, entry: null },
            },
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe((confirmed) => {
                if (!confirmed) return;
                this.deleteTag(tag);
            });
    }

    private deleteTag(tag: string): void {
        this.tagService
            .deleteTag(tag)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => this.loadTags(),
                error: () => this.messageService.error(this.translate.instant('permit.config.common.error')),
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
